import CreateLobbyModal from "./CreateLobbyModal"
import FindLobbyModal from "./FindLobbyModal"
import JoinLobbyModal from "./JoinLobbyModal"
import LoginModal from "./LoginModal"
import RegisterModal from "./RegisterModal"
import SettingsModal from "./SettingsModal"
import CityModal from "./CityModal"
import BattleModal from "./BattleModal"
import UnitModal from "./UnitModal"
import StatDetailModal from "./StatDetailModal"
import ResearchModal from "./ResearchModal"
import StatHelpModal from "./StatHelpModal"
import ZoneHelpModal from "./ZoneHelpModal"
import TunnelModal from "./TunnelModal"
import DischargeModal from "./DischargeModal"
import GameOverModal from "./GameOverModal"
import AttackModal from "./AttackModal"
import ForgotPasswordModal from "./ForgotPasswordModal"
import BuildingModal from "./BuildingModal"
import TradeModal from "./TradeModal"
import ShopModal from "./ShopModal"
import FormationModal from "./FormationModal"
import GameHistoryModal from "./GameHistoryModal"
import WatchGamesModal from "./WatchGamesModal"
import TeamModal from "./TeamModal"
import ArtShowcaseModal from "./ArtShowcaseModal"
import PlayerCardModal from "./PlayerCardModal"
import GameGraphsModal from "./GameGraphsModal"
import LookPickerModal from "./LookPickerModal"
import SaveGuestModal from "./SaveGuestModal"

const modals = [
  { name: "CreateLobbyModal", component: CreateLobbyModal },
  { name: "FindLobbyModal", component: FindLobbyModal },
  { name: "JoinLobbyModal", component: JoinLobbyModal },
  { name: "LoginModal", component: LoginModal },
  { name: "RegisterModal", component: RegisterModal },
  { name: "SettingsModal", component: SettingsModal },
  { name: "CityModal", component: CityModal },
  { name: "BattleModal", component: BattleModal },
  { name: "UnitModal", component: UnitModal },
  { name: "StatDetailModal", component: StatDetailModal },
  { name: "ResearchModal", component: ResearchModal },
  { name: "StatHelpModal", component: StatHelpModal },
  { name: "ZoneHelpModal", component: ZoneHelpModal },
  { name: "TunnelModal", component: TunnelModal },
  { name: "DischargeModal", component: DischargeModal },
  { name: "GameOverModal", component: GameOverModal },
  { name: "AttackModal", component: AttackModal },
  { name: "ForgotPasswordModal", component: ForgotPasswordModal },
  { name: "BuildingModal", component: BuildingModal },
  { name: "TradeModal", component: TradeModal },
  { name: "ShopModal", component: ShopModal },
  { name: "FormationModal", component: FormationModal },
  { name: "GameHistoryModal", component: GameHistoryModal },
  { name: "WatchGamesModal", component: WatchGamesModal },
  { name: "TeamModal", component: TeamModal },
  { name: "ArtShowcaseModal", component: ArtShowcaseModal },
  { name: "PlayerCardModal", component: PlayerCardModal },
  { name: "GameGraphsModal", component: GameGraphsModal },
  { name: "LookPickerModal", component: LookPickerModal },
  { name: "SaveGuestModal", component: SaveGuestModal },
]
const modalMapping = Object.fromEntries(modals.map((modal) => [modal.name, modal.component]))

export default modalMapping
